export default __webpack_public_path__ + "static/media/upload-file-blue.952f0308.svg";